import React from "react";

export default function Terms() {
  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px", lineHeight: "1.6" }}>
      <h1>Terms of Service</h1>

      <p>
        By using this AI travel platform, you agree to the following terms and conditions.
      </p>

      <h2>1. Use of Service</h2>
      <p>
        You agree to use the platform only for lawful purposes and in accordance with these terms.
      </p>

      <h2>2. AI & Automation</h2>
      <p>
        Our system uses AI to generate travel recommendations and detect fraud. Outputs may not always be perfect or fully accurate.
      </p>

      <h2>3. Account Responsibility</h2>
      <p>
        You are responsible for maintaining the confidentiality of your account.
      </p>

      <h2>4. Service Availability</h2>
      <p>
        We do not guarantee uninterrupted service. Maintenance or outages may occur.
      </p>

      <h2>5. Limitation of Liability</h2>
      <p>
        We are not liable for losses resulting from travel decisions, AI recommendations, or system decisions.
      </p>

      <h2>6. Changes</h2>
      <p>
        We may update these terms at any time. Continued use means acceptance of changes.
      </p>
    </div>
  );
}
